import Immutable from 'immutable';
import { createSelector } from 'reselect';

const getBrowse = state => state.getIn(['browse', 'home'], Immutable.Map());

export const selectBrowseHomeConfig = createSelector([getBrowse], browse => {
  return browse.get('config', Immutable.Map());
});

export const selectIsFetching = createSelector([getBrowse], browse => {
  return browse.get('isFetching', false);
});
